module.exports = __webpack_public_path__ + "static/media/arrowUpDark.7b16f6bc.svg";